import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity PricingProfiles


export interface PricingProfile {
    id: ID;

    
    name: string;

    
    description?: string;

    
    scopeGroupId: ID;

    }




export interface CreatePricingProfile {
    
    name: string;

    
    description?: string;

    
    }


export interface UpdatePricingProfile {
    
    name: string;

    
    description?: string;

    
    }

export interface PresentationPricingProfileRequest {
    list: ListRequest,
    filter: {
        name: string,
        nameOr: boolean,
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryPricingProfile {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: PricingProfile): PrimaryPricingProfile | undefined {
        return entity ? new PrimaryPricingProfile(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryPricingProfile {
        return new PrimaryPricingProfile(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryPricingProfile {
        let vals = path?.split('/');
        return new PrimaryPricingProfile(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryPricingProfile[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: PricingProfile): string {
    let fields = entity ? [
    entity.name,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityPricingProfile {
    id: PrimaryPricingProfile;
    data: UpdatePricingProfile;


    constructor(id: PrimaryPricingProfile, data: UpdatePricingProfile) {
        this.id = id;
        this.data = data;
    }
}
